import { render, staticRenderFns } from "./GeographyMethodology.vue?vue&type=template&id=3e3d15c0&"
import script from "./GeographyMethodology.vue?vue&type=script&lang=js&"
export * from "./GeographyMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports